'use strict';

import {brWpParticipant} from './brwpparticipant.js';

export class brWp
{
	participants = {};
	wp_id;
	no = '';
	title = '';
	id;
	
	total = {
		initial: 0,
		proposed: 0,
		reduction: 0
	};
	
	constructor(data){
		
		this.setupData(data);
		this.countTotal();
	}
	
	setupData(data){
		if(typeof(data.title) !== 'undefined' && data.title !== ''){
			this.title = data.title;
		}
		if(typeof(data.no) !== 'undefined' && data.no !== ''){
			this.no = data.no;
		}
		if(typeof(data.application_wp_id) !== 'undefined'){
			this.wp_id = data.application_wp_id;
		}
		if(typeof(data.wp_id) !== 'undefined'){
			this.wp_id = data.wp_id;
		}
		this.id = 'wp'+this.wp_id;
		if(typeof(data.participants) !== 'undefined'){
			for(let id in data.participants){
				let participant = new brWpParticipant(data.participants[id]);
				this.participants[participant.id] = participant;
			}
		}
	}
	
	countTotal(){
		let total = {
			initial: 0,
			proposed: 0,
			reduction: 0
		};
		for(let id in this.participants){
			total.initial += this.participants[id].initial;
			total.proposed += this.participants[id].proposed;
			total.reduction += this.participants[id].reduction;
		}
		this.total = total;
	}
	
	getInitial(){
		this.countTotal();
		return this.total.initial;
	}
	
	getProposed(){
		this.countTotal();
		return this.total.proposed;
	}
	
	getReduction(){
		this.countTotal();
		return this.total.reduction;
	}
	
	getParticipantsList(){
		return Object.values(this.participants);
	}
	
	getLongTitle(){
		return this.no + ' ' + this.title;
	}
}